import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import { Helpers } from 'victory'

const styles = theme => ({
  chip: {
    backgroundColor: 'rgba(224, 224, 224, 0.5)'
  }
})

const isFunction = x => {
  return Object.prototype.toString.call(x) === '[object Function]'
}

const DefaultTooltip = ({ classes, text, datum, active }) => {
  const label = isFunction ? Helpers.evaluateProp(text, datum, active) : text
  return <Chip className={classes.chip} label={label} />
}

export default withStyles(styles)(DefaultTooltip)



// WEBPACK FOOTER //
// ./src/charts/DefaultTooltip.js